const getLocalUserData = () => {
  try {
    const userData = localStorage.getItem("userData");

    if (userData) {
      return JSON.parse(userData);
    }
  } catch (err) {
    return null;
  }
};

const setLocalUserData = (data) => {
  localStorage.setItem("userData", JSON.stringify(data));
};

const clearLocalUserData = () => {
  localStorage.removeItem("userData");
};

export { getLocalUserData, setLocalUserData, clearLocalUserData };


export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const debounced = function (...args: Parameters<T>) {
    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func(...args);
    }, wait);
  };

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounced;
}

export function range(start: number, end: number): number[] {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}
